import styled from 'styled-components';

export const Box = styled.div`
  display: none;
  & > button {
    padding: 0;
    background: none;
    font-size: 14px;
    color: rgb(0, 136, 0);
    font-weight: bold;
  }
  @media (min-width: 426px) {
    display: block;
  }
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 10px;
  top: 0;
  left: 0;
  display: flex;
  width: 90%;
  height: 100%;
  background: white;
  border-right: 2px solid #ccc;
  & button {
    color: rgb(0, 136, 0);
    padding: 10px;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 20px;
    background: none;
  }
`;

export const Content = styled.div`
  width: 80%;
  padding: 10px;
  font-weight: normal;
  font-size: 14px;
  overflow-y: auto;
`;
